import React, { useContext } from 'react';
import '../styles/Footer.css';
import WeAccept from './WeAccept';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AppContext from './context/AppContext';

const Footer = ({ navLinks }) => {
    const date = new Date();
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    return (
        <footer
            className={'bg-dark text-white pt-3 pb-4 d-flex justify-content-center align-items-center'}
        >
            <div
                style={{
                    maxWidth: '1200px !important',
                }}>
                <div
                    className={'d-flex justify-content-between align-items-center flex-wrap mb-3'}>
                    <div
                        style={{
                            maxWidth: '800px',
                        }}
                        className={'d-flex justify-content-start flex-wrap'}>
                        {navLinks.map((link, idx) => (
                            <div
                                key={`${link.url}-${idx}`}
                                className={'d-flex gap-2 align-items-center'}>
                                <div
                                    className={'px-2 small footer-text'}>
                                    <a
                                        style={{
                                            textDecoration: 'none',
                                            color: 'inherit'
                                        }}
                                        href={link.url}
                                        className={'text-decoration-none'}>
                                        {link.text}
                                    </a>
                                </div>
                                {idx !== navLinks.length - 1 && (
                                    <div
                                        className={'small px-0 footer-text'}>
                                        |
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div
                        className={'mb-2 mb-md-0'}>
                        © {date.getFullYear()} Sourcefy. All rights Reserved.
                    </div>
                </div>
                <div
                    className={'d-flex justify-content-between align-items-center flex-wrap'}>
                    <div
                        style={{
                            marginLeft: '100px',
                        }}
                        className={'justify-content-center'}>
                        <div>
                            <Link
                                to={appConfig.storeShopperApprovedUrl}>
                                <img
                                    src={'https://www.shopperapproved.com/seal/39173/default-sa-seal.gif'}
                                    alt={'4.8 stars - Shopper Approved'}
                                    style={{ height: '48px' }}
                                />
                            </Link>
                        </div>
                    </div>
                    <div
                        className={'d-flex justify-content-center align-items-center flex-wrap small footer-text'}>
                        <div>
                            <WeAccept />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    navLinks: PropTypes.array,
};

export default Footer;
